module.exports = __webpack_public_path__ + "img/move-right.fba6cab3.svg";